import { render, staticRenderFns } from "./Slack.vue?vue&type=template&id=3a1867c4&scoped=true&"
import script from "./Slack.vue?vue&type=script&lang=js&"
export * from "./Slack.vue?vue&type=script&lang=js&"
import style0 from "./Slack.vue?vue&type=style&index=0&id=3a1867c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1867c4",
  null
  
)

export default component.exports